export default "__VITE_ASSET__CVL1HUrX__"